var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3808 2.63011C12.9873 2.14574 12.2759 2.05492 11.7915 2.44847C11.3071 2.84202 11.2163 3.55345 11.6098 4.03782L14.6826 7.8674H1.13525C0.514647 7.8674 0 8.38205 0 9.00266C0 9.62326 0.514647 10.1379 1.13525 10.1379H14.6674L11.5947 13.9675C11.2011 14.4519 11.2768 15.1784 11.7763 15.5568C12.2625 15.9388 12.9783 15.8582 13.3808 15.3752L17.6278 10.0641C18.1241 9.44348 18.1241 8.56183 17.6278 7.94121L13.3808 2.63011Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.74cdd1b1a2f647bcc6e896ca5ef6ec1c.svg";
export { ForwardRef as ReactComponent };